<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data: () => ({
  }),
};
</script>

<style lang="scss" scoped>
// Global background
:deep(.v-application) {
  background: #f8fafd !important;
}

:deep(.v-main) {
  background: #f8fafd !important;
}
</style>
